module.exports = __webpack_public_path__ + "static/media/bakery-lake.e5cf86cf.png";